import { createSlice } from "@reduxjs/toolkit";
import { FeeStructureResponseDto } from "../../shared/dtos/feeStructure/FeeStructureResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const feeStructureSlice = createSlice({
  name: "feeStructure",
  initialState: getInitialCrudState<FeeStructureResponseDto>(),
  reducers: {
    ...generateCrudReducers<FeeStructureResponseDto>(),
  },
});

export const feeStructureActions = feeStructureSlice.actions;
export default feeStructureSlice.reducer;
